import axios from "axios";
import { allTypeId, microbialTypeId, chemicalTypeId, celolluseTypeId, packingTypeId, environmentTypeId, atomiTypeId, gaziTypeId, mayeTypeId, nasajiTypeId, pezeshkiTypeId, behdashtiTypeId } from "../../configs/methodTypes"

export const getNewSampleNum = () => {
  return async () => {
    const results = await axios.get('/sample');
    if (results) {
      return results.data;
    }
    return false;
  }
}

export const getSamples = (requestId) => {
  return async () => {
    const results = await axios.get(`/sample/getall/${requestId}`);
    if (results) {
      return results.data;
    }
    return false;
  };
};

export const getMethodById = (id) => {
  return async () => {
    const results = await axios.get(`/samplemethod/getmethodbyid/${id}`);
    if (results) {
      return results.data;
    }
    return false;
  };
};

export const getSamplesByType = (requestId, type) => {
  return async () => {
    const results = await axios.post(`/sample/getallbytype/${requestId}`, { type });
    if (results) {
      return results.data;
    }
    return false;
  };
};

export const getSample = (id) => {
  return async () => {
    const results = await axios.get(`/sample/${id}`);
    if (results) {
      return results.data;
    }
    return false;
  };
};

export const getSampleByIdPublic = (id) => {
  return async () => {
    const results = await axios.get(`/sample/sampleByIdPublic/${id}`);
    if (results) {
      return results.data;
    }
    return false;
  };
};

export const getPointsBySampleId = (id) => {
  return async () => {
    const results = await axios.get(`/sample/points/${id}`);
    if (results) {
      return results.data;
    }
    return false;
  };
};

export const deleteSamples = (ids) => {
  return async () => {
    const results = await axios.delete(`/sample`, { data: { ids: ids } });
    if (results) {
      return true;
    }

    return false;
  };
};

export const createSample = (sample) => {
  return async () => {
    const result = await axios.post("/sample", {
      ...sample,
    });
    if (!result) {
      return false;
    }
    return result;
  };
};

export const updateSample = (sample) => {
  return async () => {
    const result = await axios.put(`/sample/${sample.id}`, {
      ...sample,
    });
    if (!result) {
      return false;
    }
    return true;
  };
};

export const updatePointsBySampleId = (id, points, descriptions) => {
  return async () => {
    const result = await axios.put(`/sample/points/${id}`, {
      points,
      descriptions,
    });
    if (!result) {
      return false;
    }
    return true;
  };
};

export const getSampleMethods = (id) => {
  return async () => {
    const result = await axios.get(`/samplemethod/getbysampleid/${id}`);
    if (!result) {
      return false;
    }
    return result.data;
  };
};

export const getScanedSampleMethods = (id) => {
  return async () => {
    const result = await axios.get(`/samplemethod/getbysampleid/${id}`);
    if (!result) {
      return false;
    }
    return result.data;
  };
};

export const getSampleMethodsByType = (id, type) => {
  return async () => {
    console.log("hereeeeeeeee", typeof type);
    let result;
    if (type === allTypeId) {
      result = await axios.post(`/samplemethod/getbysampleid/${id}`, { type });
    } else if (type == microbialTypeId) {
      result = await axios.post(`/samplemethod/getmicrobialbysampleid/${id}`, { type });
    } else if (type == chemicalTypeId) {
      result = await axios.post(`/samplemethod/getchemicalbysampleid/${id}`, { type });
    } else if (type == celolluseTypeId) {
      result = await axios.post(`/samplemethod/getcellulosbysampleid/${id}`, { type });
    } else if (type == packingTypeId) {
      result = await axios.post(`/samplemethod/getpackingbysampleid/${id}`, { type });
    } else if (type == environmentTypeId) {
      result = await axios.post(`/samplemethod/getenvironmenbysampleid/${id}`, { type });
    } else if (type == atomiTypeId) {
      result = await axios.post(`/samplemethod/getatomibysampleid/${id}`, { type });
    } else if (type == gaziTypeId) {
      result = await axios.post(`/samplemethod/getgazibysampleid/${id}`, { type });
    } else if (type == mayeTypeId) {
      result = await axios.post(`/samplemethod/getmayebysampleid/${id}`, { type });
    } else if (type == nasajiTypeId) {
      result = await axios.post(`/samplemethod/getnasajibysampleid/${id}`, { type });
    } else if (type == pezeshkiTypeId) {
      result = await axios.post(`/samplemethod/getpezeshkibysampleid/${id}`, { type });
    } else if (type == behdashtiTypeId) {
      result = await axios.post(`/samplemethod/getbehdashtibysampleid/${id}`, { type });
    }

    if (!result) {
      return false;
    }
    return result.data;
  };
};

export const deleteMethods = (ids) => {
  return async () => {
    const results = await axios.delete(`/samplemethod`, { data: { ids: ids } });
    if (results) {
      return true;
    }

    return false;
  };
};

export const createMethods = (sampleId, ids) => {
  return async () => {
    const result = await axios.post(`/samplemethod/${sampleId}`, {
      methods: ids,
    });
    if (!result) {
      return false;
    }
    return result;
  };
};

export const updateMethodPrice = (id, price) => {
  return async () => {
    const result = await axios.put(`/samplemethod/${id}`, {
      price: price,
    });
    if (!result) {
      return false;
    }
    return result;
  };
};

export const updateSampleDiscount = (id, discount) => {
  return async () => {
    const result = await axios.put(`/sample/discount/${id}`, {
      discount: discount,
    });
    if (!result) {
      return false;
    }
    return result;
  };
};

export const updateRequestTax = (id, tax) => {
  return async () => {
    const result = await axios.put(`/request/tax/${id}`, {
      tax: tax,
    });
    if (!result) {
      return false;
    }
    return result;
  };
};

export const updateMethod = (id, data) => {
  return async () => {
    const result = await axios.put(`/samplemethod/update/${id}`, data);
    if (!result) {
      return false;
    }
    return result;
  };
};

export const print = (id, data) => {
  return async () => {
    const result = await axios.post(`/sample/print/${id}`, data, {

      headers: {
        "Content-Type": "application/json",
        Accept: "text/html",
      },
    });
    if (!result) {
      return false;
    }
    return result;
  };
};

export const newPrint = (id, data) => {
  return async () => {
    const result = await axios.post(`/sample/newprint/${id}`, data, {
      // 
      headers: {
        "Content-Type": "application/json",
        Accept: "text/html",
      },
    });
    if (!result) {
      return false;
    }
    return result;
  };
};

export const verify = (id) => {
  console.log('reeeeeeeeeeeeeeeee')
  return async () => {
    const result = await axios.post(`/sample/verify/${id}`, {
      // 
      headers: {
        "Content-Type": "application/json",
        Accept: "text/html",
      },
    });
    if (!result) {
      return false;
    }
    return result;
  };
};

export const printeEvironmentResults = (id, data) => {
  return async () => {
    const result = await axios.post(`/sample/printenvironment/${id}`, data, {

      headers: {
        "Content-Type": "application/json",
        Accept: "text/html",
      },
    });
    if (!result) {
      return false;
    }
    return result;
  };
};
